import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IDocumentEngineTemplate } from '@core/entities/document-engine'
import { documentEngineTemplatesKeys } from '@core/react-query/features/templates/documentEngineTemplates'
import {
  documentEngineTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/templates/documentEngineTemplates/documentEngineTemplate'

export const useCreateDocumentEngineTemplate = (
  options?: UseMutationOptions<
    IDocumentEngineTemplate,
    RequestErrorType,
    RequestTypes['createDocumentEngineTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...documentEngineTemplateKeys.createDocumentEngineTemplate,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: documentEngineTemplatesKeys.byOrganisation({
          organisationId: variables.organisationId,
        }).queryKey,
      })
    },
    ...options,
  })
}
